import { render, staticRenderFns } from "./dd-tag.vue?vue&type=template&id=610c9336&scoped=true&"
import script from "./dd-tag.vue?vue&type=script&lang=ts&"
export * from "./dd-tag.vue?vue&type=script&lang=ts&"
import style0 from "./dd-tag.vue?vue&type=style&index=0&id=610c9336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c9336",
  null
  
)

export default component.exports